const constants = {
  perMaxLen: 90000000
};

export const useConstants = () => constants;
